// Blog data loaded from JSON to avoid babel-metadata-plugin stack overflow
// eslint-disable-next-line
const blogPostsData = require('./blogData.json');

export const allBlogPosts = blogPostsData;

export const getBlogBySlug = (slug) => allBlogPosts.find(post => post.slug === slug);

export const getBlogByServiceId = (serviceId) => allBlogPosts.find(post => post.serviceId === serviceId);

export const getRelatedBlogs = (slugs) => slugs.map(slug => getBlogBySlug(slug)).filter(Boolean);
